import { defineNuxtPlugin, useHead } from '#imports';

import font300 from '~/assets/fonts/montserrat-v26-cyrillic_latin-300.woff2?url';
import font400 from '~/assets/fonts/montserrat-v26-cyrillic_latin-regular.woff2?url';
import font500 from '~/assets/fonts/montserrat-v26-cyrillic_latin-500.woff2?url';
import font600 from '~/assets/fonts/montserrat-v26-cyrillic_latin-600.woff2?url';
import font700 from '~/assets/fonts/montserrat-v26-cyrillic_latin-700.woff2?url';

/**
 * Шрифты браузер находит только после разбора entry.css — то есть с задержкой
 * около полусекунды, и они успевают подмениться уже после первой отрисовки.
 * Это давало CLS на текстовых блоках (Lighthouse показывал «Web font loaded»).
 *
 * Preload поднимает их в очереди раньше; байты те же, меняется только приоритет.
 * Веса ниже — те, что реально загружаются на страницах (замер по Lighthouse).
 */
export default defineNuxtPlugin(() => {
  useHead({
    link: [font300, font400, font500, font600, font700].map(href => ({
      rel: 'preload',
      as: 'font',
      type: 'font/woff2',
      href,
      crossorigin: 'anonymous',
    })),
  });
});
